export default {
  state: {
    originalRsvp: null,
    editedRsvp: {
      serviceCode: '',
      serviceId: ''
    }
  },
  mutations: {
    setOriginalRsvp (state, value) {
      state.originalRsvp = value
    },
    setEditedRsvp (state, value) { state.editedRsvp = value },
    setEditedPickup (state, value) { state.editedRsvp.pickup = value },
    setEditedDropoff (state, value) { state.editedRsvp.dropoff = value },
    setEditedPickupTime (state, value) { state.editedRsvp.pickupTime = value },
    setEditedDistance (state, value) { state.editedRsvp.distance = value },
    setEditedETA (state, value) { state.editedRsvp.eta = value },
    setEditedPassenger (state, value) { state.editedRsvp.passengers = value },
    setEditedLuggage (state, value) { state.editedRsvp.luggage = value },
    setEditedPickupType (state, value) { state.editedRsvp.pickupType = value },
    setEditedPickupFee (state, value) { state.editedRsvp.payment.pickupFee = value },
    setEditedWheelchair (state, value) { state.editedRsvp.ada.wheelchair = value },
    setEditedServiceDog (state, value) { state.editedRsvp.ada.serviceDog = value },
    setEditedGuest (state, value) { state.editedRsvp.guest = value },
    setEditedNotes (state, value) { state.editedRsvp.notes = value },
    setEditedFlight (state, flight) {
      state.editedRsvp.airlineCode = flight.airlineCode
      state.editedRsvp.airline = flight.airline
      state.editedRsvp.flightNumber = flight.flightNumber
    },
    setEditedStop (state, data) {
      state.editedRsvp.extraStops[data.index] = data.value
    },
    addExtraStop (state, value) {
      if (!state.editedRsvp.extraStops) {
        state.editedRsvp.extraStops = []
      }
      state.editedRsvp.extraStops.push(value)
    },
    removeExtraStop (state, index) {
      let hackFix = [].concat(state.originalRsvp.extraStops)
      state.editedRsvp.extraStops.splice(index, 1)
      state.originalRsvp.extraStops = hackFix
    },
    emptyEditedService (state, value) {
      state.editedRsvp.serviceId = value
      state.editedRsvp.serviceCode = value ? `a${value}` : ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/rsvp-edit/reservation.js